import React from "react";
import { Popup } from "semantic-ui-react";
import {
  calendarCell,
  cellHeader,
  cellText,
  lock,
  mock,
  calendarCellWrapper,
  popUpRow,
  M0,
  popUpHeader,
  pointer
} from "./ApplicationsCalendar.module.css";
import { calendarDaysType } from "./calendarUtils";
const CalendarCell = ({
  header,
  uploading,
  unloading,
  unloadingApproved,
  uploadingApproved,
  unloadingNotApproved,
  uploadingNotApproved,
  dayType,
  translates,
  ...props
}) => {
  const getStyles = (dayType) => {
    switch (dayType) {
      case "mock":
        return mock;
      case "lock":
        return `${lock} ${pointer}`;
      default:
        return `${pointer}`;
    }
  };
  return (
    <div className={`${calendarCellWrapper}`}>
      <div className={`${calendarCell} ${getStyles(dayType)}`} {...props}>
        <div className={cellHeader}>{header}</div>
        {dayType !== calendarDaysType.MOCK && (
          <div className={cellText}>
            {dayType === calendarDaysType.PREV_LOCK ? (
              <Popup
                content={
                  <div>
                    <div>
                      {translates.unloading} {unloading} {`${translates.tonsShort.toLowerCase()}.`}
                    </div>
                    <div>
                      {translates.uploading} {uploading} {`${translates.tonsShort.toLowerCase()}.`}
                    </div>
                  </div>
                }
                inverted
                mouseEnterDelay={500}
                position="top center"
                trigger={
                  <div>
                    {unloading}/{uploading}
                  </div>
                }
              />
            ) : (
              <Popup
                content={
                  <div>
                    <div className={`${popUpRow}`}>
                      <div className={`${popUpHeader}`}>{translates.approved}:</div>
                      <div>
                        <div>
                          {translates.unloading} {unloadingApproved} {`${translates.tonsShort.toLowerCase()}.`}
                        </div>
                        <div>
                          {translates.uploading} {uploadingApproved} {`${translates.tonsShort.toLowerCase()}.`}
                        </div>
                      </div>
                    </div>
                    <div className={`${popUpRow} ${M0}`}>
                      <div className={`${popUpHeader}`}>{translates.notApproved}:</div>
                      <div>
                        <div>
                          {translates.unloading} {unloadingNotApproved} {`${translates.tonsShort.toLowerCase()}.`}
                        </div>
                        <div>
                          {translates.uploading} {uploadingNotApproved} {`${translates.tonsShort.toLowerCase()}.`}
                        </div>
                      </div>
                    </div>
                  </div>
                }
                inverted
                mouseEnterDelay={500}
                position="top center"
                trigger={
                  <div>
                    <div>
                      {unloadingApproved}/{uploadingApproved}
                    </div>
                    <div>
                      {unloadingNotApproved}/{uploadingNotApproved}
                    </div>
                  </div>
                }
              />
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default CalendarCell;
